var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 11.1002V5.7002H12.9V11.1002H18.3V12.9002H12.9V18.3002H11.1V12.9002H5.69995V11.1002H11.1Z",
    fill: "#008556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLine1);
export default __webpack_public_path__ + "static/media/add-line (1).d102900f5ff0af2934e41481644dcf04.svg";
export { ForwardRef as ReactComponent };